import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import cuid from 'cuid';
import PropTypes from 'prop-types';
import states from 'states-us';
import translate from '@/lib/intl/translate';

const formattedStates = states.map(({ name, abbreviation }) => ({
  label: name,
  value: abbreviation,
}));

export default function USAStateSelect({
  FormHelperTextProps,
  className,
  disabled,
  helperText,
  id,
  onChange,
  value,
}) {
  const [uid] = React.useState(id || cuid());

  return (
    <FormControl className={className} disabled={disabled}>
      <InputLabel
        className="whitespace-nowrap"
        id={`usa-state-select-label-${uid}`}
      >
        {translate('FORMS_STATE_LABEL')}
      </InputLabel>
      <Select
        disabled={disabled}
        label={translate('FORMS_STATE_LABEL')}
        labelId={`usa-state-select-label-${uid}`}
        id={`usa-state-select-${uid}`}
        name="state"
        value={value}
        className="w-full"
        onChange={onChange}
      >
        <MenuItem value="">
          <em>{translate('NONE')}</em>
        </MenuItem>
        {formattedStates.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>

      {helperText && (
        <FormHelperText {...FormHelperTextProps}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

USAStateSelect.propTypes = {
  FormHelperTextProps: PropTypes.shape({
    className: PropTypes.string,
  }),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

USAStateSelect.defaultProps = {
  FormHelperTextProps: {},
  className: '',
  disabled: false,
  helperText: null,
  id: null,
  onChange: () => {},
  value: '',
};
